import {DragAndDrop} from '@github-ui/drag-and-drop'
import {testIdProps} from '@github-ui/test-id-props'
import {Checkbox} from '@primer/react'
import {clsx} from 'clsx'

import {useListViewSelection} from '../ListView/SelectionContext'
import {useListViewVariant} from '../ListView/VariantContext'
import {useListItemAlignment} from './AlignmentContext'
import listItemStyles from './ListItem.module.css'
import styles from './Selection.module.css'
import {useListItemSelection} from './SelectionContext'
import {useListItemTitle} from './TitleContext'

export const ListItemSelection = () => {
  const {variant} = useListViewVariant()
  const {isSelectable, isSelectionDisabled, hasDragHandle} = useListViewSelection()
  const {isSelected, onSelect} = useListItemSelection()
  const {title} = useListItemTitle()
  const {alignment} = useListItemAlignment()

  if (!isSelectable) return null

  return (
    <div
      className={clsx(
        hasDragHandle ? styles.containerWithDragHandle : styles.container,
        alignment === 'center' && styles.centerAligned,
      )}
      {...testIdProps('list-view-item-selection')}
    >
      {hasDragHandle && (
        <DragAndDrop.DragTrigger className={clsx(styles.dragTrigger, variant === 'compact' && styles.compact)} />
      )}
      <Checkbox
        className={clsx(
          styles.checkbox,
          listItemStyles.leadingElement,
          alignment === 'center' && listItemStyles.centerAligned,
        )}
        checked={isSelected}
        aria-disabled={isSelectionDisabled}
        onChange={event => {
          if (!isSelectionDisabled) {
            const isRangeSelection = event.nativeEvent instanceof MouseEvent && event.nativeEvent.shiftKey
            if (isRangeSelection) onSelect(!isSelected, true)
            else onSelect(!isSelected)
          }
        }}
        aria-label={`Select: ${title}`}
        data-listview-component="selection-input"
        {...testIdProps('list-view-item-selection-input')}
      />
    </div>
  )
}
